<template>
  <div v-editable="blok" class="blok contained">
    <div class="blok-container" ref="shopify">
      <component
        :key="index"
        v-for="(child,index) in blok.renderer"
        :products="products"
        :blok="child"
        :is="child.component"
        @descreaseBasketItem="onDescreaseBasketItem"
        @increaseBasketItem="onIncreaseBasketItem"
        @removeFromBasket="onRemoveVariantFromBasket"
        @addProductToBasket="onAddProductToBasket"
      ></component>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
//
import ShopifyService from "../../service/shopifyService";
import SimpleProductList from "./shopify/SimpleProductList";

export default {
  name: "shopify-container",
  data: () => {
    return {
      products: [],
      selectedProduct: null
    };
  },
  components: {
    "shopify-simple-product-list": SimpleProductList
  },
  props: {
    blok: Object
  },
  methods: {
    ...mapActions("shopify", [
      "getAllProducts",
      "addProductToShopifyCart",
      "removeProductFromShopifyCart",
      "descreaseBasketItem",
      "increaseBasketItem",
      "getAllProductsFromCollection"
    ]),
    ...mapActions("analytics", ["trackAddToCart","trackRemoveFromCart"]),
    onAddProductToBasket: function(product, index = 0) {
      this.addProductToShopifyCart(product);
      this.trackAdd(product, 1);
    },
    onDescreaseBasketItem: function(item) {
      this.descreaseBasketItem(item);
      this.trackRemove(item, item.quantity-1);
    },
    onIncreaseBasketItem: function(item) {
      this.increaseBasketItem(item);
      this.trackAdd(item, item.quantity+1);
    },
    onRemoveVariantFromBasket: function(lineItem) {
      this.removeProductFromShopifyCart(lineItem);
      this.trackRemove(lineItem, lineItem.quantity);
    },
    trackRemove: function(lineItem, quantity) {
      this.trackRemoveFromCart({
          "id": lineItem.id,
          "name": lineItem.title,
          "list_name": lineItem.title,
          "category": lineItem.productType,
          "variant": lineItem.sku,
          "price": lineItem.price,
          "quantity": quantity 
        });
    },
    trackAdd: function(product,quantity) {
      this.trackAddToCart({
          "id": product.id,
          "name": product.title,
          "list_name": product.title,
          "category": product.productType,
          "variant": product.sku,
          "price": product.price,
          "quantity": quantity
        });
    }
  },
  mounted: async function() {
    const blok = this.$props.blok;
    if (blok.collection && blok.collection.id) {
      this.products = await this.getAllProductsFromCollection(blok.collection.id);
    } else {
      this.products = await this.getAllProducts();
    }
  }
};
</script>
